import { render, staticRenderFns } from "./UrlRedirect.vue?vue&type=template&id=255dcabe&scoped=true"
import script from "./UrlRedirect.vue?vue&type=script&lang=js"
export * from "./UrlRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255dcabe",
  null
  
)

export default component.exports